export default __webpack_public_path__ + "static/APHP-026edb57cab13e62ef96010735554397.png";